import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent } from "@/components/ui/dropdown-menu";

export function NotificationsBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const i = setInterval(load, 60000); return () => clearInterval(i); }, []);
  const openChange = (o) => {
    if (o && data.unread) api.post("/notifications/read-all").then(() => setData((d) => ({ ...d, unread: 0 }))).catch(() => {});
  };
  return (
    <DropdownMenu onOpenChange={openChange}>
      <DropdownMenuTrigger asChild>
        <button data-testid="notifications-bell" aria-label="Notifications"
          className="relative w-9 h-9 rounded-full flex items-center justify-center text-muted-foreground hover:text-foreground">
          <Bell size={18} />
          {data.unread > 0 && (
            <span data-testid="notifications-count" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-primary text-white text-[10px] flex items-center justify-center">{data.unread}</span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 omy-glass max-h-96 overflow-y-auto p-0">
        <div className="px-3 py-2.5 text-sm font-medium border-b border-white/5">Notifications</div>
        {data.items.length === 0 && <div className="px-3 py-6 text-sm text-muted-foreground text-center">Aucune notification</div>}
        {data.items.map((n, i) => (
          <div key={n.id} data-testid={`notification-${i}`} className="px-3 py-2.5 border-b border-white/5 last:border-0">
            <p className="text-sm">{n.title}</p>
            {n.body && <p className="text-xs text-muted-foreground mt-0.5">{n.body}</p>}
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
